import React from 'react';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { FailedSolutions } from '../components/FailedSolutions';
import { Mechanism } from '../components/Mechanism';
import { WhatYouGet } from '../components/WhatYouGet';
import { ForWho } from '../components/ForWho';
import { Pricing } from '../components/Pricing';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-[#FAF7F2] text-[#2D2A26] font-sans selection:bg-[#C4A35A] selection:text-white" data-id="element-177">
      <Hero data-id="element-178" />
      <PainSection data-id="element-179" />
      <FailedSolutions data-id="element-180" />
      <Mechanism data-id="element-181" />
      <WhatYouGet data-id="element-182" />
      <ForWho data-id="element-183" />
      <Pricing data-id="element-184" />
      <Footer data-id="element-185" />
    </div>;
}